import { render } from "./FeedView.vue?vue&type=template&id=592b22fa"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"

import "./FeedView.vue?vue&type=style&index=0&id=592b22fa&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__